import React from "react";
import MyColorPicker from "./MyColorPicker";

export function ColorPicker({
  color = "rgb(130,80,223)",
  onChange,
  pickerWidth,
  pickerHeight,
}) {
  return (
    <MyColorPicker
      color={color}
      onChange={onChange}
      pickerWidth={pickerWidth}
      pickerHeight={pickerHeight}
    />
  );
}

export default ColorPicker;
